/// <reference path="../assets.d.ts" />
import { Asset } from 'expo-asset';
import type { ImageSource } from '../image.types';
import landscapeLightAsset from './landscape-light.webp';

// Web variant. The bundled WebP's URL, which the image layer fetches.
export const landscapeLight: ImageSource = Asset.fromModule(landscapeLightAsset).uri;
